import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/ui/tooltip.tsx");
